import { set } from 'date-fns';

function setTime(date: Date, time24h: string): Date {
  // Validate and parse the 24-hour time string using a regular expression
  const timeMatch = time24h.match(/^(\d{2}):(\d{2})$/);
  if (!timeMatch) {
    throw new Error('Invalid time format. Expected format: HH:mm');
  }

  const [, hoursStr, minutesStr] = timeMatch;
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
    throw new Error(
      'Invalid time. Hours must be between 0-23 and minutes between 0-59.'
    );
  }

  // Use date-fns set to apply the new time
  return set(date, { hours, minutes });
}

export default setTime;
